import { render, staticRenderFns } from "./contentAudit.vue?vue&type=template&id=9fa415ba&scoped=true"
import script from "./contentAudit.vue?vue&type=script&lang=js"
export * from "./contentAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa415ba",
  null
  
)

export default component.exports